import { render, staticRenderFns } from "./courseDetail.vue?vue&type=template&id=220d6c44&scoped=true"
import script from "./courseDetail.vue?vue&type=script&lang=js"
export * from "./courseDetail.vue?vue&type=script&lang=js"
import style0 from "../../courseCenter/assets/css/detail.scss?vue&type=style&index=0&id=220d6c44&prod&lang=scss&scoped=true&external"
import style1 from "../asset/css/courseDetail.scss?vue&type=style&index=1&id=220d6c44&prod&lang=scss&scoped=true&external"
import style2 from "./courseDetail.vue?vue&type=style&index=2&id=220d6c44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220d6c44",
  null
  
)

export default component.exports